export const categories = [
  {
    id: 'riben',
    name: '日本樱花',
    slug: 'japan-sakura',
    description: '日本各地樱花盛开实拍视频，从京都岚山到东京上野公园，记录扶桑之国最浪漫的粉色季节。',
    icon: 'ri-global-line',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20cherry%20blossom%20garden%20in%20full%20bloom%20with%20traditional%20temple%20background%2C%20soft%20pink%20sakura%20trees%20lining%20a%20path%2C%20warm%20natural%20light%2C%20serene%20atmosphere%2C%20artistic%20photography%20style%20with%20gentle%20color%20palette&width=800&height=500&seq=cat-japan-01&orientation=landscape',
    count: 128,
  },
  {
    id: 'wuhan',
    name: '武汉樱花',
    slug: 'wuhan-sakura',
    description: '武汉大学樱花大道与东湖磨山樱花园实拍，中国最美的樱花之城，每年三月迎来百万游客赏樱。',
    icon: 'ri-building-line',
    image: 'https://readdy.ai/api/search-image?query=Wuhan%20University%20cherry%20blossom%20avenue%20with%20historic%20buildings%2C%20pink%20sakura%20trees%20in%20full%20bloom%2C%20spring%20sunlight%2C%20crowds%20of%20visitors%2C%20romantic%20atmosphere%2C%20editorial%20photography%20style&width=800&height=500&seq=cat-wuhan-02&orientation=landscape',
    count: 96,
  },
  {
    id: 'beijing',
    name: '北京樱花',
    slug: 'beijing-sakura',
    description: '玉渊潭公园樱花节实拍，京城最著名的赏樱胜地，樱花与古典园林的完美融合。',
    icon: 'ri-map-pin-line',
    image: 'https://readdy.ai/api/search-image?query=Beijing%20Yuyuantan%20Park%20cherry%20blossom%20festival%20with%20lake%20reflections%2C%20pink%20and%20white%20sakura%20trees%2C%20traditional%20Chinese%20pavilion%20in%20background%2C%20spring%20atmosphere%2C%20bright%20natural%20lighting&width=800&height=500&seq=cat-beijing-03&orientation=landscape',
    count: 84,
  },
  {
    id: 'piaoluo',
    name: '樱花飘落',
    slug: 'falling-sakura',
    description: '樱花飘落的唯美瞬间，慢动作捕捉花瓣飞舞的浪漫画面，每一帧都是诗意。',
    icon: 'ri-leaf-line',
    image: 'https://readdy.ai/api/search-image?query=Cherry%20blossom%20petals%20falling%20gently%20in%20the%20wind%2C%20soft%20pink%20petals%20floating%20against%20blue%20sky%2C%20dreamy%20and%20romantic%20atmosphere%2C%20slow%20motion%20effect%2C%20artistic%20photography%2C%20minimalist%20composition&width=800&height=500&seq=cat-falling-04&orientation=landscape',
    count: 72,
  },
  {
    id: 'yanshi',
    name: '延时摄影',
    slug: 'timelapse-sakura',
    description: '樱花从含苞待放到盛开飘落的延时摄影作品，记录生命的绽放与凋零之美。',
    icon: 'ri-time-line',
    image: 'https://readdy.ai/api/search-image?query=Sakura%20blossom%20time%20lapse%20photography%2C%20cherry%20tree%20going%20from%20buds%20to%20full%20bloom%2C%20dramatic%20sky%20transitions%2C%20artistic%20nature%20photography%2C%20soft%20pink%20and%20green%20contrast&width=800&height=500&seq=cat-timelapse-05&orientation=landscape',
    count: 56,
  },
  {
    id: 'sucai',
    name: '高清素材',
    slug: 'hd-footage',
    description: '4K高清樱花视频素材，适合视频创作、背景素材、商业项目使用，免费下载。',
    icon: 'ri-vidicon-line',
    image: 'https://readdy.ai/api/search-image?query=Ultra%20HD%204K%20cherry%20blossom%20closeup%20footage%2C%20detailed%20pink%20sakura%20flowers%20with%20dew%20drops%2C%20professional%20cinematography%2C%20clean%20minimal%20background%2C%20vibrant%20yet%20soft%20color%20palette&width=800&height=500&seq=cat-hd-06&orientation=landscape',
    count: 160,
  },
];